var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04167 0.625C2.59042 0.625 0.625 2.59042 0.625 5.04167V35.9583C0.625 38.4096 2.59042 40.375 5.04167 40.375H35.9583C38.4096 40.375 40.375 38.4096 40.375 35.9583V5.04167C40.375 2.59042 38.4096 0.625 35.9583 0.625H5.04167ZM5.04167 5.04167H35.9583V35.9583H5.04167V5.04167ZM9.45833 9.45833V13.875H31.5417V9.45833H9.45833ZM9.45833 18.2917V22.7083H31.5417V18.2917H9.45833ZM9.45833 27.125V31.5417H24.9167V27.125H9.45833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentbox);
export default __webpack_public_path__ + "static/media/documentbox.d1ae9e660f5e85c4625dad6cefb08c05.svg";
export { ForwardRef as ReactComponent };